var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('Input',{attrs:{"placeholder":"搜索"},on:{"on-enter":_vm.searchBtn},model:{value:(_vm.queryText),callback:function ($$v) {_vm.queryText=$$v},expression:"queryText"}}),_c('span',{staticClass:"iconfont icon-sousuo",attrs:{"slot":"prepend"},on:{"click":_vm.searchBtn},slot:"prepend"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }